import { PurchaseTemplate } from 'types/ProductDetailsType';
import Button from 'components/atomic/Button';

type RegistrationAgainProps = {
  register: any;
};

const RegistrationAgain: React.FC<RegistrationAgainProps> = ({ register }) => {
  return (
    <div className='w-full flex flex-col items-center justify-start gap-5 py-2 overflow-auto overflow-x-hidden'>
      <p>You are going to register this product again. Are you sure?</p>
      <Button
        variant='black'
        onClick={register}
        title={'Yes I have multiple products'}
      />
    </div>
  );
};

export default RegistrationAgain;
